import { components } from '@/utils'

function renderOverlay(h) {
  return h(
    'div',
    {
      class: `${components.dialog}__overlay`,
      on: {
        click: this.closeOnClickHandler,
        wheel: this.onWheel
      }
    }
  )
}

function renderHandle(h) {
  if (this.isMobileView) {
    return h(
      'div',
      {
        class: `${components.dialog}__handle`,
        on: {
          touchstart: this.touchStart,
          touchend: this.touchEnd
        }
      }
    )
  }
}

function renderTitle(h) {
  if (this.title) {
    return h(
      'div',
      {
        class: `${components.dialog}__title`
      },
      [ this.title ]
    )
  }
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${components.dialog}__header`
    },
    [ this.$slots.header || renderTitle.call(this, h) ]
  )
}

function renderBody(h) {
  return h(
    'div',
    {
      class: `${components.dialog}__body`,
      style: this.bodyStyle,
      ref: 'body',
      on: {
        wheel: event => {
          event.stopPropagation()
        }
      }
    },
    [ this.$slots.default ]
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: `${components.dialog}__footer`
    },
    [ this.$slots.footer ]
  )
}

function renderContent(h) {
  if (this.proxy) {
    return h(
      'div',
      {
        class: this.$class,
        style: { 'z-index': this.zIndex }
      },
      [
        h(
          'div',
          {
            class: `${components.dialog}__holder`,
            style: this.holderStyle,
            ref: 'holder',
            on: { wheel: this.onWheel }
          },
          [
            renderHandle.call(this, h),
            renderHeader.call(this, h),
            renderBody.call(this, h),
            renderFooter.call(this, h)
          ]
        ),

        renderOverlay.call(this, h)
      ]
    )
  }
}

export default function(h) {
  let mobileModifier = ''
  if (this.isMobileView) {
    mobileModifier = '--mobile'
  }

  return h(
    'transition',
    {
      props: { name: `show-dialog${mobileModifier}` }
    },
    [ renderContent.call(this, h) ]
  )
}
